import { getResult } from '../../helpers/request';
import { bffServiceClient } from '../../packages/request/clients';

const getTeam = (params: any) => {
  return bffServiceClient
    .get(`/team`, {
      params: params,
    })
    .then(getResult);
};

const getSale = (params: any) => {
  return bffServiceClient
    .get(`/staff/children`, {
      params: params,
    })
    .then(getResult);
};

const getApproachingReport = (params: any) => {
  return bffServiceClient
    .get(`/ticket/approaching`, {
      params: params,
    })
    .then(getResult);
};

const getApproachingReportExcel = (params: any) => {
  return bffServiceClient.post(`/ticket/export`, params, {
    responseType: 'blob',
  });
};

export default {
  getTeam,
  getSale,
  getApproachingReport,
  getApproachingReportExcel,
};
